import type { DashboardEmployeeIdp } from '../../types';
import { DashboardSection } from '../DashboardSection';
import { EmployeeIdpTable } from './EmployeeIdpTable';

interface Props {
  className?: string;
  currentEmployeeId: string;
  data: Array<DashboardEmployeeIdp>;
  loading: boolean;
}

export const EmployeeIdp = ({ className, currentEmployeeId, data, loading }: Props) => (
  <DashboardSection className={className} title="IDP">
    <EmployeeIdpTable currentEmployeeId={currentEmployeeId} data={data} loading={loading} />
  </DashboardSection>
);
